import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {  } from "../actions/localStates"
import {  } from "../actions/api"

import VerifyDSView from '../components/VerifyDSView';

class VerifyContainer extends Component {

	render() {
		return (
			<VerifyDSView />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
 
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyContainer);